import { z } from "zod/v4";
import { createEndpointBase } from "./core";
import { CodeTemplateGroupSchemas, CodeTemplatesSchemas } from "../ea.schema";
import { CountResponseSchema } from "../ea.schema.endpoints";
import {
  GetRequestBaseResponseSchema,
  CodeTemplatesFilterSchema,
  CodeTemplateGroupsFilterSchema,
} from "../ea.schema.query";

const base = "code-templates";
const ct = createEndpointBase(base);
const groups = createEndpointBase(base, "groups");

export const codeTemplatesEndpoints = {
  codeTemplatesGet: ct({
    method: "GET",
    path: "",
    request: z.object({ filter: CodeTemplatesFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(CodeTemplatesSchemas["general"]),
    description: "Retrieves a list of code templates with filtering support.",
  }),
  codeTemplatesCount: ct({
    method: "GET",
    path: "count",
    request: z
      .object({ filter: CodeTemplatesFilterSchema.pick({ where: true }).optional() })
      .optional(),
    response: CountResponseSchema,
    description: "Returns the total number of code templates matching the filters.",
  }),
  codeTemplatesCreate: ct({
    method: "POST",
    path: "",
    request: CodeTemplatesSchemas["createData"],
    response: CodeTemplatesSchemas["general"],
    description: "Creates a new code template.",
  }),
  codeTemplatesUpdate: ct({
    method: "PATCH",
    path: ":id",
    request: CodeTemplatesSchemas["update"],
    response: CodeTemplatesSchemas["general"],
    description: "Updates an existing code template.",
  }),
  codeTemplatesDelete: ct({
    method: "DELETE",
    path: ":id",
    request: CodeTemplatesSchemas["general"].pick({ id: true }),
    response: z.any(),
    description: "Permanently deletes a code template.",
  }),
  codeTemplatesExport: ct({
    method: "POST",
    path: "export",
    request: z.object({ codeTemplateIds: z.array(z.coerce.number()) }),
    response: z.any(),
    description: "Exports specified code templates to a file.",
  }),
  codeTemplatesImport: ct({
    method: "POST",
    path: "import",
    request: z.any(),
    response: z.array(
      z.object({ name: z.string(), imported: z.boolean(), error: z.string().optional() }),
    ),
    description: "Imports code templates from uploaded files.",
  }),

  codeTemplateGroupsGet: groups({
    method: "GET",
    path: "",
    request: z.object({ filter: CodeTemplateGroupsFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(CodeTemplateGroupSchemas["general"]),
    description: "Retrieves a list of code template groups with filtering support.",
  }),
  codeTemplateGroupsCount: groups({
    method: "GET",
    path: "count",
    request: z.any(),
    response: CountResponseSchema,
    description: "Returns the total number of code template groups matching the filters.",
  }),
  codeTemplateGroupsCreate: groups({
    method: "POST",
    path: "",
    request: CodeTemplateGroupSchemas["create"],
    response: CodeTemplateGroupSchemas["general"],
    description: "Creates a new code template group.",
  }),
  codeTemplateGroupsUpdate: groups({
    method: "PATCH",
    path: ":id",
    request: CodeTemplateGroupSchemas["update"],
    response: CodeTemplateGroupSchemas["general"],
    description: "Updates an existing code template group.",
  }),
  codeTemplateGroupsDelete: groups({
    method: "DELETE",
    path: ":id",
    request: CodeTemplateGroupSchemas["general"].pick({ id: true }),
    response: z.any(),
    description: "Permanently deletes a code template group.",
  }),
} as const;
